import { Dispatch, createContext, useContext } from "react";
import { IAction } from "./actions/i-action";

export const DispatchContext = createContext<Dispatch<IAction>>(() => {
  // default
});

export const useDispatch = (): Dispatch<IAction> =>
  useContext<Dispatch<IAction>>(DispatchContext);
